<div class="thp-form-container">
  <form [formGroup]="vmsEmploymentHistoryAndRelationshipForm">
    <div class="field-group thp-form" *ngIf="!employmentHistoryCompleted && showEmploymentHistory()">
      <label class="thp-header">{{"talent-happy-path.talent-vms.employment-history.label" | translate }}</label>
      <div class="field-group">
        <ng-container *ngIf="clientEmploymentHistory.employmentTypeRequired; else noEmploymentType">
          <label class="field-label">
            {{"talent-happy-path.talent-vms.employment-history.worked-for-client" | translate: {clientName: clientName} }}
            <i>{{"talent-happy-path.talent-vms.employment-history.select-all-that-apply" | translate}}</i>
          </label>
          <mat-chip-listbox multiple formControlName="selectedEmploymentTypeIds">
            <mat-chip-option
                    *ngFor="let type of employmentTypes"
                    [value]="type.id"
                    selectable="true">
              {{ type.label | translate }}
            </mat-chip-option>
          </mat-chip-listbox>
        </ng-container>
        <ng-template #noEmploymentType>
          <label class="field-label">
            {{"talent-happy-path.talent-vms.employment-history.worked-for-client" | translate: {clientName: clientName} }}
          </label>
          <mat-radio-group aria-labelledby="worked-for-client-radio-group-label" formControlName="workedWithClient">
            <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
          </mat-radio-group>
        </ng-template>
      </div>
    </div>

    <ng-container *ngIf="clientEmploymentHistory.employmentTypeRequired; else noEmploymentType">
      <ng-container *ngFor="let employmentType of employmentTypes">
        <div class="field-group thp-form" *ngIf="!isOnlyEmploymentTypeRequired && (vmsEmploymentHistoryAndRelationshipForm.get('selectedEmploymentTypeIds')?.value ?? []).includes(employmentType.id)">
          <label class="thp-header label-row">
            {{ "talent-happy-path.talent-vms.employment-history.most-recent-employment-type-experience" | translate:{employmentType: (employmentType.label | translate)} }}
            <button class="icon-button">
              <img (click)="deleteTab(employmentType.id)" ngSrc="assets/icons/trash_icon.svg" alt="Delete employment experience" height="48" width="48">
            </button>
          </label>
          <div class="field-group">
            <div *ngIf="clientEmploymentHistory.employmentDateRequired">
              <div class="vms-header">
                <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.dates" | translate}}</label>
              </div>
              <app-date-range-picker
                [employmentTypeLabel]="employmentType.label"
                (selectedDateRangeChange)="onEmploymentDateRangeChange($event)"
                [form]="vmsEmploymentHistoryAndRelationshipForm"
                [startDateFormControlName]="(employmentType.label | translate).toLowerCase() + 'StartDate'"
                [endDateFormControlName]="(employmentType.label | translate).toLowerCase() + 'EndDate'"
                [personId]="personId">
              </app-date-range-picker>
            </div>
            <div *ngIf="clientEmploymentHistory.endReasonRequired">
              <mat-form-field style="width: 100%">
                <input matInput [formControlName]="(employmentType.label | translate).toLowerCase() + 'EndReason'" placeholder="Reason for ending" #endReasonInput maxlength="90">
                <mat-hint align="end">{{ endReasonInput.value.length }} / 90</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="field-group" *ngIf="clientEmploymentHistory.managerNameRequired || clientEmploymentHistory.titleRequired
                                                || clientEmploymentHistory.departmentRequired || clientEmploymentHistory.knownEmailRequired
                                                || clientEmploymentHistory.jobLocationRequired">
            <div class="vms-header">
              <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.details" | translate}}</label>
            </div>
            <div class="field-group employment-fields-grid">
              <ng-container *ngFor="let field of employmentHistoryDetailFields">
                <ng-container *ngIf="field.required">
                  <mat-form-field>
                    <input matInput [formControlName]="(employmentType.label | translate).toLowerCase() + field.control" [placeholder]="field.placeholder">
                  </mat-form-field>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="field-group" *ngIf="(employmentType.id === VmsEmploymentType.Contract || employmentType.id === VmsEmploymentType.Vendor)
                              && clientEmploymentHistory.previousAgencyRequired">
            <div class="vms-header">
              <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.agency-name" | translate}}</label>
            </div>
            <div class="field-group">
              <mat-form-field style="width: 100%">
                <input matInput [formControlName]="(employmentType.label | translate).toLowerCase() + 'PreviousAgency'" placeholder="Agency Name" type="text">
                <mat-hint>{{"talent-happy-path.talent-vms.employment-history.type-none-if-no-agency" | translate}}</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noEmploymentType>
      <div class="field-group thp-form" *ngIf="!isOnlyEmploymentTypeRequired && vmsEmploymentHistoryAndRelationshipForm.get('workedWithClient')?.value === true">
        <label class="thp-header label-row">
          {{ "talent-happy-path.talent-vms.employment-history.most-recent-experience" | translate }}
        </label>
        <div class="field-group">
          <div *ngIf="clientEmploymentHistory.employmentDateRequired">
            <div class="vms-header">
              <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.dates" | translate}}</label>
            </div>
            <app-date-range-picker
              (selectedDateRangeChange)="onEmploymentDateRangeChange($event)"
              [form]="vmsEmploymentHistoryAndRelationshipForm"
              [startDateFormControlName]="'mostRecentStartDate'"
              [endDateFormControlName]="'mostRecentEndDate'"
              [personId]="personId">
            </app-date-range-picker>
          </div>
          <div *ngIf="clientEmploymentHistory.endReasonRequired">
            <mat-form-field style="width: 100%">
              <input matInput formControlName="mostRecentEndReason" placeholder="Reason for ending" #endReasonInput maxlength="90">
              <mat-hint align="end">{{ endReasonInput.value.length }} / 90</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="field-group" *ngIf="clientEmploymentHistory.managerNameRequired || clientEmploymentHistory.titleRequired
                                                || clientEmploymentHistory.departmentRequired || clientEmploymentHistory.knownEmailRequired
                                                || clientEmploymentHistory.jobLocationRequired">
          <div class="vms-header">
            <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.details" | translate}}</label>
          </div>
          <div class="field-group employment-fields-grid">
            <ng-container *ngFor="let field of employmentHistoryDetailFields">
              <ng-container *ngIf="field.required">
                <mat-form-field>
                  <input matInput [formControlName]="'mostRecent' + field.control" [placeholder]="field.placeholder">
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="field-group" *ngIf="clientEmploymentHistory.previousAgencyRequired">
          <div class="vms-header">
            <label class="field-label">{{"talent-happy-path.talent-vms.employment-history.agency-name" | translate}}</label>
          </div>
          <div class="field-group">
            <mat-form-field style="width: 100%">
              <input matInput formControlName="mostRecentPreviousAgency" placeholder="Agency Name" type="text">
              <mat-hint>{{"talent-happy-path.talent-vms.employment-history.type-none-if-no-agency" | translate}}</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="field-group thp-form" *ngIf="!relationshipDisclosureCompleted && showRelationshipDisclosure()">
      <label class="thp-header">{{"talent-happy-path.talent-vms.relationship-disclosure.label" | translate }}</label>
      <div class="field-group">
        <label class="field-label">{{"talent-happy-path.talent-vms.relationship-disclosure.does-a-family-member-work" | translate: {clientName: clientName} }}</label>
        <mat-radio-group aria-labelledby="worked-for-client-radio-group-label" formControlName="familyMemberWorksWithClient">
          <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
          <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="field-group thp-form" *ngIf="vmsEmploymentHistoryAndRelationshipForm.get('familyMemberWorksWithClient')?.value === true">
      <label class="thp-header">{{"talent-happy-path.talent-vms.relationship-disclosure.family-member-name" | translate }}</label>
      <div class="field-group" *ngIf="clientVmsSubInfo.relationshipDisclosureRequired">
        <mat-form-field style="width: 100%">
          <mat-label class="field-label">{{"talent-happy-path.talent-vms.relationship-disclosure.family-member-name" | translate}}</mat-label>
          <input matInput formControlName="familyMemberName" name="familyMemberName" type="text">
        </mat-form-field>
      </div>
      <label class="thp-header">{{"talent-happy-path.talent-vms.relationship-disclosure.relationship.label" | translate }}</label>
      <div class="field-group" *ngIf="clientVmsSubInfo.relationshipDisclosureRequired">
        <mat-form-field style="width: 100%">
          <mat-select formControlName="relationshipTypeId">
            <mat-option *ngFor="let type of relationshipTypes" [value]="type.id">
              {{ type.label | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-group thp-form" *ngIf="!ernstAndYoungEmploymentHistoryCompleted && showErnstAndYoungHistory()">
      <label id="worked-for-client-radio-group-label" class="thp-header">{{"talent-happy-path.talent-vms.ernst-and-young-history.label" | translate }}</label>
      <div class="field-group">
        <label class="field-label">{{"talent-happy-path.talent-vms.ernst-and-young-history.have-you-worked" | translate}}</label>
        <mat-radio-group aria-labelledby="worked-for-client-radio-group-label" formControlName="ernstAndYoungEmploymentHistory">
          <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
          <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
        </mat-radio-group>
        </div>
      <div class="field-group" *ngIf="vmsEmploymentHistoryAndRelationshipForm.get('ernstAndYoungEmploymentHistory')?.value === true">
        <label id="engaged-on-account-radio-group-label" class="field-label">{{"talent-happy-path.talent-vms.ernst-and-young-history.engaged-on-account" | translate: {clientName: clientName} }}</label>
        <mat-radio-group aria-labelledby="engaged-on-account-radio-group-label" formControlName="ernstAndYoungEngagedOnClientAccount">
          <mat-radio-button [value]="true">{{"talent-happy-path.radio.yes" | translate}}</mat-radio-button>
          <mat-radio-button [value]="false">{{"talent-happy-path.radio.no" | translate}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </form>
  <div class="button-container">
    <button id="employment-history-submittal-button"
            mat-button
            class="custom-button single-custom-button"
            [disabled]="disableSubmit()"
            (click)="submitEmploymentHistoryAndRelationship()">
      {{"talent-happy-path.buttons.submit" |translate }}
    </button>
    <button *ngIf="isFromGather()"
            mat-button class="later-button" (click)="doThisLater()">{{"talent-happy-path.buttons.do-later" | translate}}</button>
    </div>
</div>
